import type { ComponentType } from 'react';
import { memo } from 'react';

import {
  type ITimelineEventProps,
  TimelineEvent,
} from './components/TimelineEvent'
import { TimelineStyled } from './styles/TimelineStyled'

export interface ITimelineProps {
  data: ITimelineEventProps[]
}

export const Timeline: ComponentType<ITimelineProps> = memo(
  ({ data }) => {
    const renderTimelineEvents = () => {
      // Reverse the data so the 'newest' event is at the top of the line
      const reversedData = [...data].reverse()

      return reversedData.map((event, index) => {
        return (
          <TimelineEvent
            key={index}
            title={event.title}
            metadata={event.metadata}
            icon={event.icon}
            iconCircle={event.iconCircle}
            status={event.status ? event.status : null}
          />
        )
      })
    }

    return (
      <TimelineStyled>
        {data.length > 0 && renderTimelineEvents()}
      </TimelineStyled>
    )
  }
)
